/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetCreditStatusByIdResponse,
  CardApplicationResponse,
  SaveCreditCardApplicationResponse,
  SaveCreditCardApplicationRequest,
  UtxCardApplicationGetCreditCardApplicationParams,
  CreateCreditCardApplicationResponse,
  CreateCreditCardApplicationRequest,
  GetCardProductListResponse,
  PlaceBorrowInstructionResponse,
  PlaceBorrowInstructionRequest,
  PlaceRepayInstructionResponse,
  PlaceRepayInstructionRequest,
  SetAlertThresholdResponse,
  SetAlertThresholdRequest,
  SetAutoPayForOverdraftResponse,
  SetAutoPayForOverdraftRequest,
  CreditTransactionsResponse,
  GetAssetBackedResponse,
  CreditSummaryResponse,
  GetAutoPayAssetResponse,
  SetAutoPayAssetResponse,
  SetAutoPayAssetRequest,
  GetAutopayAssetsSequenceResponse,
  GetAutopaySettingsResponse,
  SetAutoPayResponse,
  SetAutoPayRequest,
  GetCardRepaymentResponse,
  UtxCardCreditGetCardRepaymentParams,
  GetCreditLineLtvResponse
} from './schema'



export const utxCardApplicationGetCreditStatusById = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCreditStatusByIdResponse>> => {
    return axios.get(
      `/credit/card`,options
    );
  }


export const getUtxCardApplicationGetCreditStatusByIdQueryKey = () => [`/credit/card`];

    
export type UtxCardApplicationGetCreditStatusByIdQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardApplicationGetCreditStatusById>>>
export type UtxCardApplicationGetCreditStatusByIdQueryError = AxiosError<void>

export const useUtxCardApplicationGetCreditStatusById = <TData = Awaited<ReturnType<typeof utxCardApplicationGetCreditStatusById>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardApplicationGetCreditStatusById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardApplicationGetCreditStatusByIdQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardApplicationGetCreditStatusById>>> = ({ signal }) => utxCardApplicationGetCreditStatusById({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardApplicationGetCreditStatusById>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardApplicationSaveCreditCardStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardApplicationResponse>> => {
    return axios.post(
      `/credit/card`,undefined,options
    );
  }



    export type UtxCardApplicationSaveCreditCardStatusMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardStatus>>>
    
    export type UtxCardApplicationSaveCreditCardStatusMutationError = AxiosError<void>

    export const useUtxCardApplicationSaveCreditCardStatus = <TError = AxiosError<void>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardStatus>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardStatus>>, TVariables> = () => {
          

          return  utxCardApplicationSaveCreditCardStatus(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardStatus>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardApplicationSaveCreditCardApplication = (
    saveCreditCardApplicationRequest: SaveCreditCardApplicationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SaveCreditCardApplicationResponse>> => {
    return axios.post(
      `/credit/card/application`,
      saveCreditCardApplicationRequest,options
    );
  }



    export type UtxCardApplicationSaveCreditCardApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardApplication>>>
    export type UtxCardApplicationSaveCreditCardApplicationMutationBody = SaveCreditCardApplicationRequest
    export type UtxCardApplicationSaveCreditCardApplicationMutationError = AxiosError<void>

    export const useUtxCardApplicationSaveCreditCardApplication = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardApplication>>, TError,{data: SaveCreditCardApplicationRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardApplication>>, {data: SaveCreditCardApplicationRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardApplicationSaveCreditCardApplication(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardApplicationSaveCreditCardApplication>>, TError, {data: SaveCreditCardApplicationRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardApplicationGetCreditCardApplication = (
    params: UtxCardApplicationGetCreditCardApplicationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardApplicationResponse[]>> => {
    return axios.get(
      `/credit/card/application`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardApplicationGetCreditCardApplicationQueryKey = (params: UtxCardApplicationGetCreditCardApplicationParams,) => [`/credit/card/application`, ...(params ? [params]: [])];

    
export type UtxCardApplicationGetCreditCardApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardApplication>>>
export type UtxCardApplicationGetCreditCardApplicationQueryError = AxiosError<void>

export const useUtxCardApplicationGetCreditCardApplication = <TData = Awaited<ReturnType<typeof utxCardApplicationGetCreditCardApplication>>, TError = AxiosError<void>>(
 params: UtxCardApplicationGetCreditCardApplicationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardApplication>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardApplicationGetCreditCardApplicationQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardApplication>>> = ({ signal }) => utxCardApplicationGetCreditCardApplication(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardApplication>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardApplicationCreateCreditCardApplicationV2 = (
    createCreditCardApplicationRequest: CreateCreditCardApplicationRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateCreditCardApplicationResponse>> => {
    return axios.post(
      `/credit/card/application-v2`,
      createCreditCardApplicationRequest,options
    );
  }



    export type UtxCardApplicationCreateCreditCardApplicationV2MutationResult = NonNullable<Awaited<ReturnType<typeof utxCardApplicationCreateCreditCardApplicationV2>>>
    export type UtxCardApplicationCreateCreditCardApplicationV2MutationBody = CreateCreditCardApplicationRequest
    export type UtxCardApplicationCreateCreditCardApplicationV2MutationError = AxiosError<void>

    export const useUtxCardApplicationCreateCreditCardApplicationV2 = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardApplicationCreateCreditCardApplicationV2>>, TError,{data: CreateCreditCardApplicationRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardApplicationCreateCreditCardApplicationV2>>, {data: CreateCreditCardApplicationRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxCardApplicationCreateCreditCardApplicationV2(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardApplicationCreateCreditCardApplicationV2>>, TError, {data: CreateCreditCardApplicationRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardApplicationGetCreditCardProductList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardProductListResponse[]>> => {
    return axios.get(
      `/credit/card/application/products`,options
    );
  }


export const getUtxCardApplicationGetCreditCardProductListQueryKey = () => [`/credit/card/application/products`];

    
export type UtxCardApplicationGetCreditCardProductListQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardProductList>>>
export type UtxCardApplicationGetCreditCardProductListQueryError = AxiosError<void>

export const useUtxCardApplicationGetCreditCardProductList = <TData = Awaited<ReturnType<typeof utxCardApplicationGetCreditCardProductList>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardProductList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardApplicationGetCreditCardProductListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardProductList>>> = ({ signal }) => utxCardApplicationGetCreditCardProductList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardApplicationGetCreditCardProductList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditSetOpenAccount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/credit/open-account`,undefined,options
    );
  }



    export type UtxCardCreditSetOpenAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditSetOpenAccount>>>
    
    export type UtxCardCreditSetOpenAccountMutationError = AxiosError<unknown>

    export const useUtxCardCreditSetOpenAccount = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditSetOpenAccount>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditSetOpenAccount>>, TVariables> = () => {
          

          return  utxCardCreditSetOpenAccount(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditSetOpenAccount>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditPlaceBorrowInstruction = (
    id: string,
    placeBorrowInstructionRequest: PlaceBorrowInstructionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlaceBorrowInstructionResponse>> => {
    return axios.post(
      `/credit/${id}/borrow`,
      placeBorrowInstructionRequest,options
    );
  }



    export type UtxCardCreditPlaceBorrowInstructionMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditPlaceBorrowInstruction>>>
    export type UtxCardCreditPlaceBorrowInstructionMutationBody = PlaceBorrowInstructionRequest
    export type UtxCardCreditPlaceBorrowInstructionMutationError = AxiosError<unknown>

    export const useUtxCardCreditPlaceBorrowInstruction = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditPlaceBorrowInstruction>>, TError,{id: string;data: PlaceBorrowInstructionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditPlaceBorrowInstruction>>, {id: string;data: PlaceBorrowInstructionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardCreditPlaceBorrowInstruction(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditPlaceBorrowInstruction>>, TError, {id: string;data: PlaceBorrowInstructionRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditPlaceRepayInstruction = (
    id: string,
    placeRepayInstructionRequest: PlaceRepayInstructionRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlaceRepayInstructionResponse>> => {
    return axios.post(
      `/credit/${id}/repay`,
      placeRepayInstructionRequest,options
    );
  }



    export type UtxCardCreditPlaceRepayInstructionMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditPlaceRepayInstruction>>>
    export type UtxCardCreditPlaceRepayInstructionMutationBody = PlaceRepayInstructionRequest
    export type UtxCardCreditPlaceRepayInstructionMutationError = AxiosError<unknown>

    export const useUtxCardCreditPlaceRepayInstruction = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditPlaceRepayInstruction>>, TError,{id: string;data: PlaceRepayInstructionRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditPlaceRepayInstruction>>, {id: string;data: PlaceRepayInstructionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardCreditPlaceRepayInstruction(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditPlaceRepayInstruction>>, TError, {id: string;data: PlaceRepayInstructionRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditSetAlertThreshold = (
    id: string,
    setAlertThresholdRequest: SetAlertThresholdRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetAlertThresholdResponse>> => {
    return axios.post(
      `/credit/${id}/alert-threshold`,
      setAlertThresholdRequest,options
    );
  }



    export type UtxCardCreditSetAlertThresholdMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditSetAlertThreshold>>>
    export type UtxCardCreditSetAlertThresholdMutationBody = SetAlertThresholdRequest
    export type UtxCardCreditSetAlertThresholdMutationError = AxiosError<unknown>

    export const useUtxCardCreditSetAlertThreshold = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditSetAlertThreshold>>, TError,{id: string;data: SetAlertThresholdRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditSetAlertThreshold>>, {id: string;data: SetAlertThresholdRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardCreditSetAlertThreshold(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditSetAlertThreshold>>, TError, {id: string;data: SetAlertThresholdRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditSetAutoPayForOverdraft = (
    id: string,
    setAutoPayForOverdraftRequest: SetAutoPayForOverdraftRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetAutoPayForOverdraftResponse>> => {
    return axios.post(
      `/credit/${id}/set-autopay/overdraft`,
      setAutoPayForOverdraftRequest,options
    );
  }



    export type UtxCardCreditSetAutoPayForOverdraftMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditSetAutoPayForOverdraft>>>
    export type UtxCardCreditSetAutoPayForOverdraftMutationBody = SetAutoPayForOverdraftRequest
    export type UtxCardCreditSetAutoPayForOverdraftMutationError = AxiosError<unknown>

    export const useUtxCardCreditSetAutoPayForOverdraft = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditSetAutoPayForOverdraft>>, TError,{id: string;data: SetAutoPayForOverdraftRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditSetAutoPayForOverdraft>>, {id: string;data: SetAutoPayForOverdraftRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardCreditSetAutoPayForOverdraft(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditSetAutoPayForOverdraft>>, TError, {id: string;data: SetAutoPayForOverdraftRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditGetCreditOverdraftTransactions = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreditTransactionsResponse>> => {
    return axios.get(
      `/credit/${id}/transactions/overdraft`,options
    );
  }


export const getUtxCardCreditGetCreditOverdraftTransactionsQueryKey = (id: string,) => [`/credit/${id}/transactions/overdraft`];

    
export type UtxCardCreditGetCreditOverdraftTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetCreditOverdraftTransactions>>>
export type UtxCardCreditGetCreditOverdraftTransactionsQueryError = AxiosError<unknown>

export const useUtxCardCreditGetCreditOverdraftTransactions = <TData = Awaited<ReturnType<typeof utxCardCreditGetCreditOverdraftTransactions>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetCreditOverdraftTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetCreditOverdraftTransactionsQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetCreditOverdraftTransactions>>> = ({ signal }) => utxCardCreditGetCreditOverdraftTransactions(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetCreditOverdraftTransactions>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditGetAssetBacked = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAssetBackedResponse>> => {
    return axios.get(
      `/credit/asset-backed`,options
    );
  }


export const getUtxCardCreditGetAssetBackedQueryKey = () => [`/credit/asset-backed`];

    
export type UtxCardCreditGetAssetBackedQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetAssetBacked>>>
export type UtxCardCreditGetAssetBackedQueryError = AxiosError<unknown>

export const useUtxCardCreditGetAssetBacked = <TData = Awaited<ReturnType<typeof utxCardCreditGetAssetBacked>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetAssetBacked>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetAssetBackedQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetAssetBacked>>> = ({ signal }) => utxCardCreditGetAssetBacked({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetAssetBacked>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditGetCreditById = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreditSummaryResponse>> => {
    return axios.get(
      `/credit/${id}`,options
    );
  }


export const getUtxCardCreditGetCreditByIdQueryKey = (id: string,) => [`/credit/${id}`];

    
export type UtxCardCreditGetCreditByIdQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetCreditById>>>
export type UtxCardCreditGetCreditByIdQueryError = AxiosError<unknown>

export const useUtxCardCreditGetCreditById = <TData = Awaited<ReturnType<typeof utxCardCreditGetCreditById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetCreditById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetCreditByIdQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetCreditById>>> = ({ signal }) => utxCardCreditGetCreditById(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetCreditById>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditGetAutopayAssets = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAutoPayAssetResponse>> => {
    return axios.get(
      `/credit/${id}/autopay-assets`,options
    );
  }


export const getUtxCardCreditGetAutopayAssetsQueryKey = (id: string,) => [`/credit/${id}/autopay-assets`];

    
export type UtxCardCreditGetAutopayAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssets>>>
export type UtxCardCreditGetAutopayAssetsQueryError = AxiosError<unknown>

export const useUtxCardCreditGetAutopayAssets = <TData = Awaited<ReturnType<typeof utxCardCreditGetAutopayAssets>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssets>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetAutopayAssetsQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssets>>> = ({ signal }) => utxCardCreditGetAutopayAssets(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssets>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditSetAutopayAssets = (
    id: string,
    setAutoPayAssetRequest: SetAutoPayAssetRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetAutoPayAssetResponse>> => {
    return axios.post(
      `/credit/${id}/set-autopay-assets`,
      setAutoPayAssetRequest,options
    );
  }



    export type UtxCardCreditSetAutopayAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditSetAutopayAssets>>>
    export type UtxCardCreditSetAutopayAssetsMutationBody = SetAutoPayAssetRequest
    export type UtxCardCreditSetAutopayAssetsMutationError = AxiosError<unknown>

    export const useUtxCardCreditSetAutopayAssets = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditSetAutopayAssets>>, TError,{id: string;data: SetAutoPayAssetRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditSetAutopayAssets>>, {id: string;data: SetAutoPayAssetRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardCreditSetAutopayAssets(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditSetAutopayAssets>>, TError, {id: string;data: SetAutoPayAssetRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditGetAutopayAssetsSequence = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAutopayAssetsSequenceResponse>> => {
    return axios.get(
      `/credit/${id}/autopay-assets-enabled`,options
    );
  }


export const getUtxCardCreditGetAutopayAssetsSequenceQueryKey = (id: string,) => [`/credit/${id}/autopay-assets-enabled`];

    
export type UtxCardCreditGetAutopayAssetsSequenceQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssetsSequence>>>
export type UtxCardCreditGetAutopayAssetsSequenceQueryError = AxiosError<unknown>

export const useUtxCardCreditGetAutopayAssetsSequence = <TData = Awaited<ReturnType<typeof utxCardCreditGetAutopayAssetsSequence>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssetsSequence>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetAutopayAssetsSequenceQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssetsSequence>>> = ({ signal }) => utxCardCreditGetAutopayAssetsSequence(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetAutopayAssetsSequence>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditGetAutopaySettings = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAutopaySettingsResponse>> => {
    return axios.get(
      `/credit/${id}/autopay-settings`,options
    );
  }


export const getUtxCardCreditGetAutopaySettingsQueryKey = (id: string,) => [`/credit/${id}/autopay-settings`];

    
export type UtxCardCreditGetAutopaySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetAutopaySettings>>>
export type UtxCardCreditGetAutopaySettingsQueryError = AxiosError<unknown>

export const useUtxCardCreditGetAutopaySettings = <TData = Awaited<ReturnType<typeof utxCardCreditGetAutopaySettings>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetAutopaySettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetAutopaySettingsQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetAutopaySettings>>> = ({ signal }) => utxCardCreditGetAutopaySettings(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetAutopaySettings>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditSetAutoPay = (
    id: string,
    setAutoPayRequest: SetAutoPayRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetAutoPayResponse>> => {
    return axios.post(
      `/credit/${id}/set-autopay/card`,
      setAutoPayRequest,options
    );
  }



    export type UtxCardCreditSetAutoPayMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditSetAutoPay>>>
    export type UtxCardCreditSetAutoPayMutationBody = SetAutoPayRequest
    export type UtxCardCreditSetAutoPayMutationError = AxiosError<unknown>

    export const useUtxCardCreditSetAutoPay = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardCreditSetAutoPay>>, TError,{id: string;data: SetAutoPayRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardCreditSetAutoPay>>, {id: string;data: SetAutoPayRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardCreditSetAutoPay(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardCreditSetAutoPay>>, TError, {id: string;data: SetAutoPayRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardCreditGetCardRepayment = (
    id: string,
    params?: UtxCardCreditGetCardRepaymentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardRepaymentResponse>> => {
    return axios.get(
      `/credit/${id}/transactions/card-repayment`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardCreditGetCardRepaymentQueryKey = (id: string,
    params?: UtxCardCreditGetCardRepaymentParams,) => [`/credit/${id}/transactions/card-repayment`, ...(params ? [params]: [])];

    
export type UtxCardCreditGetCardRepaymentQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetCardRepayment>>>
export type UtxCardCreditGetCardRepaymentQueryError = AxiosError<unknown>

export const useUtxCardCreditGetCardRepayment = <TData = Awaited<ReturnType<typeof utxCardCreditGetCardRepayment>>, TError = AxiosError<unknown>>(
 id: string,
    params?: UtxCardCreditGetCardRepaymentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetCardRepayment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetCardRepaymentQueryKey(id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetCardRepayment>>> = ({ signal }) => utxCardCreditGetCardRepayment(id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetCardRepayment>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardCreditGetCreditLineLtv = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCreditLineLtvResponse>> => {
    return axios.get(
      `/credit/ltv/${id}`,options
    );
  }


export const getUtxCardCreditGetCreditLineLtvQueryKey = (id: string,) => [`/credit/ltv/${id}`];

    
export type UtxCardCreditGetCreditLineLtvQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardCreditGetCreditLineLtv>>>
export type UtxCardCreditGetCreditLineLtvQueryError = AxiosError<unknown>

export const useUtxCardCreditGetCreditLineLtv = <TData = Awaited<ReturnType<typeof utxCardCreditGetCreditLineLtv>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardCreditGetCreditLineLtv>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardCreditGetCreditLineLtvQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardCreditGetCreditLineLtv>>> = ({ signal }) => utxCardCreditGetCreditLineLtv(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardCreditGetCreditLineLtv>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

